import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { CardElement } from "@stripe/react-stripe-js";
import { Checkbox, Form, Input } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import FormStore from "~/stores/FormStore";
import "../styles/StripeElement.less";

@observer
class CreditCardFormFields extends Component {
  render() {
    const {
      formStore,
      t,
      validation,
      serverValidationErrors,
      showSaveCreditCardField,
      showIsDefaultField,
    } = this.props;
    const { model, setProperty, getAggregatedError, onBlur } = formStore;

    return (
      <>
        <div className="side-page-input">
          <h4>{t("billingCentral:creditCardInformation")}</h4>
          <div className="field">
            <label>* {t("card")}</label>
            <CardElement />
          </div>
        </div>

        <div className="side-page-input">
          <Form.Field
            control={Input}
            name="nameOnCard"
            label={`* ${t("nameCard")}`}
            value={model.nameOnCard}
            onBlur={onBlur}
            onChange={e => setProperty("nameOnCard", e.target.value)}
            error={getAggregatedError("nameOnCard", validation, serverValidationErrors)}
            placeholder="Jane Doe"
          />
        </div>

        <div className="side-page-input">
          <Form.Field
            control={Input}
            name="street"
            label={t("billingAddressWithNumber", { number: 1 })}
            value={model.street}
            onBlur={onBlur}
            onChange={e => setProperty("street", e.target.value)}
            placeholder="622 South Ave SE"
          />
        </div>

        <div className="side-page-input">
          <Form.Field
            control={Input}
            name="street2"
            label={t("billingAddressWithNumber", { number: 2 })}
            value={model.street2}
            onBlur={onBlur}
            onChange={e => setProperty("street2", e.target.value)}
            placeholder="StudioFlex Apts"
          />
        </div>

        <div className="side-page-input">
          <Form.Field
            control={Input}
            name="city"
            label={`${t("town")}/${t("city")}`}
            value={model.city}
            onBlur={onBlur}
            onChange={e => setProperty("city", e.target.value)}
            placeholder="San Diego"
          />
        </div>

        <div className="side-page-input">
          <Form.Field
            control={Input}
            name="state"
            label={t("state")}
            value={model.state}
            onBlur={onBlur}
            onChange={e => setProperty("state", e.target.value)}
            placeholder="CA"
          />
        </div>

        {showSaveCreditCardField && (
          <div className="side-page-input">
            <Form.Field
              control={Checkbox}
              label={t("billingCentral:saveCreditCard")}
              checked={model.saveCreditCard}
              onChange={() => setProperty("saveCreditCard", !model.saveCreditCard)}
              error={getAggregatedError("saveCreditCard", validation, serverValidationErrors)}
            />
          </div>
        )}

        {showIsDefaultField && (
          <div className="side-page-input">
            <Form.Field
              control={Checkbox}
              label={t("billingCentral:saveAsDefaultCreditCard")}
              checked={model.isDefault}
              onChange={() => setProperty("isDefault", !model.isDefault)}
              error={getAggregatedError("isDefault", validation, serverValidationErrors)}
            />
          </div>
        )}
      </>
    );
  }
}

CreditCardFormFields.propTypes = {
  formStore: PropTypes.instanceOf(FormStore),
  t: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  serverValidationErrors: PropTypes.object.isRequired,
  showSaveCreditCardField: PropTypes.bool.isRequired,
  showIsDefaultField: PropTypes.bool.isRequired,
};

export default withTranslation()(CreditCardFormFields);
